import HELPER from '@/app/utils/HELPER';
import { Atom } from '../Atom';
import { ChildProductAtomRender } from '../atom-service/render/ChildProductAtomRender';
import GpChildProductExportService from '../atom-service/export/GpChildProductExportService';
/**
 * Hero Banner Atom Module
 */
export class GpChildProduct extends Atom {
  public $el: JQuery;
  public atomRender: ChildProductAtomRender;

  /**
   * @override initAtomRender
   */
  initAtomRender() {
    const atomRender = new ChildProductAtomRender(this);
    this.atomRender = atomRender;
  }

  /**
   * initAtomExport
   */
  initAtomExport() {
    this.atomServiceExportData = new GpChildProductExportService(this);
  }

  /**
   * GetModuleId
   * @returns number
   */
  getModuleId() {
    let moduleId = HELPER.MakeIdInsideList(this.$el);
    if (moduleId == '') {
      moduleId = this.$el.attr('data-id') || HELPER.MakeId().toString();
    }

    return moduleId;
  }
}
